import React from 'react';
import './PageHeader.css';

/**
 * PageHeader — Consistent page-level header
 * 
 * @param {string} title - Page title
 * @param {string} subtitle - Optional description
 * @param {React.ReactNode} icon - Optional icon
 * @param {React.ReactNode} action - Right-side actions (buttons, filters)
 * @param {React.ReactNode} breadcrumb - Breadcrumb component
 */
const PageHeader = ({
  title,
  subtitle,
  icon,
  action,
  breadcrumb,
  className = '',
}) => {
  return (
    <div className={`ck-page-header ${className}`}>
      {breadcrumb && <div className="ck-page-header-breadcrumb">{breadcrumb}</div>}
      <div className="ck-page-header-main">
        <div className="ck-page-header-left">
          {icon && <span className="ck-page-header-icon">{icon}</span>}
          <div className="ck-page-header-text">
            <h1 className="ck-page-header-title">{title}</h1>
            {subtitle && <p className="ck-page-header-subtitle">{subtitle}</p>}
          </div>
        </div>
        {action && <div className="ck-page-header-action">{action}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
